// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import masterSource from "@mastersource/XDL/PreStyle/colors";
import { xBaseTheme, xBlueprintName } from "@pacific/XDL/types";

export const colors = {
    primary: {
        main: "#1D4E99",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#AC7631",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FBFBFC",
        backgroundContrast: "#363636",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#CCCCCC",
        disabled: "#CCCCCC",
        ui1: "#FFFFFF",
        ui2: "#EEEEEE",
        ui3: "#CCCCCC",
        ui4: "#999999",
        ui5: "#666666",
        ui6: "#333333",
        ui7: "#000000",
        ui8: "#0067DB",
        ui9: "#001C3B",
        ui10: "#D3453B",
        ui11: "#F8473A",
        ui12: "#9F2F27",
        ui13: "#FBFBFC",
        ui14: "#ECE9E4",
        ui15: "#F4F4F4",
        ui16: "#F2FEF9",
        ui17: "#FFFAFB",
        ui18: "#FFFEF4",
        ui19: "#FAFDFF",
        ui20: "#E8E8E8",
        white:"#FFFFFF"
    },
    text: {
        main: "#3B3B3B",
        disabled: "#475353",
        accent: "#2D3435",
        link: "#1D4E99",
    },
    success: {
        main: "#00A65A",
        contrast: "#FFFFFF",
        light: "#D9F2E7",
    },
    danger: {
        main: "#CA3327",
        contrast: "#FFFFFF",
        light: "#FFFAFB",
    },
    warning: {
        main: "#DDAB01",
        contrast: "#FFFFFF",
        light: "#FFFEF4",
    },
    info: {
        main: "#53ACDB",
        contrast: "#FFFFFF",
        light: "#FAFDFF",
    },
} as xBaseTheme["colors"];

const systemColors = BLUEPRINT_NAME as xBlueprintName === "mastersource" ? masterSource : colors;
export default systemColors;
